import fareModel from "../model/FareModel";
import highRageRateModel from "../model/HighRangeRateModel";
import waitingTimeModel from "../model/WaitingTimeModel";
import destinationCostModel from "../model/DestinationCostModel";
import destinationModel from "../model/DestinationModel";
import peakTimeModel from "../model/PeakTimeCharge";
import BookingModel from "../model/BookingModel";


export const calculateFareAmount = () => {

    let distance = BookingModel.tripDistance || 0;
    const destination = BookingModel.destination || '';
    let additionalDistance = BookingModel.adjustDistance || 0;
    let waitingTime = BookingModel.waitMinute || 0;


    // console.log("Destination:", destination);
    // console.log("Distance:", distance);



    additionalDistance = isNaN(additionalDistance) || additionalDistance === '' ? 0 : additionalDistance;
    // console.log("Additional Distance:", additionalDistance);

    waitingTime = isNaN(waitingTime) || waitingTime === '' ? 0 : waitingTime;
    // console.log("Waiting Time:", waitingTime);

    const baseRate = fareModel.ordinaryRate;
    // console.log("Base Rate:", baseRate);

    const originalDistance = distance;
    let baseAmount = Math.round(originalDistance * baseRate);
    // console.log("Base Amount (initial):", baseAmount);

    let fareAmount = baseAmount;
    // console.log("Fare Amount (initial):", fareAmount);

    const highRangeRate = highRageRateModel.findRateByDestination(destination);
    const highRangeAmount = highRangeRate ? Math.round(highRangeRate) : 0;
    // console.log("High Range Amount:", highRangeAmount);

    fareAmount += highRangeAmount;
    // console.log("Fare Amount after adding High Range Amount:", fareAmount);

    const tollCharge = destinationModel.getTollByName(destination);
    const tollChargeAmount = tollCharge ? tollCharge : 0;
    // console.log("Toll Charge Amount:", tollChargeAmount);

    fareAmount += tollChargeAmount;
    // console.log("Fare Amount after adding Toll Charge Amount:", fareAmount);

    distance += parseFloat(additionalDistance);
    // console.log("Adjusted Distance:", distance);

    // Apply minimum KM logic - use minimum KM if calculated distance is less
    const minimumKM = fareModel.minimumKM || 0;
    const actualCalculatedDistance = distance; // Store actual calculated distance before applying minimum
    const effectiveDistance = minimumKM > 0 ? Math.max(distance, minimumKM) : distance;
    const isMinimumKMApplied = minimumKM > 0 && effectiveDistance > distance;
    // console.log("Effective Distance (with minimum KM):", effectiveDistance);

    // Calculate additional distance fare based on the difference between effective and original distance
    const additionalDistanceFare = (effectiveDistance - originalDistance) * baseRate;
    // console.log("Additional Distance Fare:", additionalDistanceFare);

    fareAmount += additionalDistanceFare;
    // console.log("Fare Amount after adding Additional Distance Fare:", fareAmount);

    const waitingTimeRate = waitingTimeModel.getChargeForWaitTime(waitingTime);
    const waitingTimeCharge = Math.round(waitingTimeRate);
    // console.log("Waiting Time Charge:", waitingTimeCharge);

    fareAmount += waitingTimeCharge;
    // console.log("Fare Amount after adding Waiting Time Charge:", fareAmount);


    const isCurrentlyPeakTime = peakTimeModel.isPeakTime();
    // console.log("Is Peak Time:", isCurrentlyPeakTime);

    const peakTimeCharge = isCurrentlyPeakTime ? fareModel.peakTimeCharge : 0;
    // console.log("Peak Time Charge:", peakTimeCharge);

    fareAmount += peakTimeCharge;
    // console.log("Fare Amount after adding Peak Time Charge:", fareAmount);

    let surchargeAmount;
    if (fareModel.surchargePercent === 0) {
        surchargeAmount = effectiveDistance * fareModel.surchargePerKM;

    } else {
        surchargeAmount = fareAmount * (fareModel.surchargePercent / 100);
    }
    surchargeAmount = Math.round(surchargeAmount);
    // console.log("Surcharge Amount:", surchargeAmount);

    const totalServiceCharge = surchargeAmount + Math.round(BookingModel.cardCharge);
    // console.log("Total Service Charge:", totalServiceCharge);


    const SGSTTaxAmount = totalServiceCharge * (fareModel.SGSTPercent / 100);
    const CGSTTaxAmount = totalServiceCharge * (fareModel.CGSTPercent / 100);
    // console.log("SGST Tax Amount:", SGSTTaxAmount);
    // console.log("CGST Tax Amount:", CGSTTaxAmount);



    const totalValue = fareAmount + totalServiceCharge;

    const totalFare = fareAmount + surchargeAmount;
    // console.log("Total Fare Amount (Before Taxes):", totalValue);

    const totalAmount = Math.round(
        totalValue +
        SGSTTaxAmount +
        CGSTTaxAmount
    );
    // console.log("Total Amount (Including Taxes and Card Charge):", totalAmount);


    destinationCostModel.destinationName = destination;
    destinationCostModel.destinationKM = effectiveDistance;
    destinationCostModel.adjustDistance = additionalDistance;
    destinationCostModel.waitMinute = waitingTime;
    destinationCostModel.isMinimumKMApplied = isMinimumKMApplied;
    destinationCostModel.actualCalculatedDistance = actualCalculatedDistance;

    destinationCostModel.baseAmount = parseFloat(Math.round(baseAmount)).toFixed(2);
    destinationCostModel.tollCharge = parseFloat(Math.round(tollCharge)).toFixed(2);
    destinationCostModel.additionalCharge = parseFloat(Math.round(additionalDistanceFare)).toFixed(2);
    destinationCostModel.waitingCharge = parseFloat(waitingTimeCharge).toFixed(2);
    destinationCostModel.surCharge = parseFloat(surchargeAmount).toFixed(2);
    destinationCostModel.CGST = parseFloat(CGSTTaxAmount).toFixed(2);
    destinationCostModel.SGST = parseFloat(SGSTTaxAmount).toFixed(2);
    destinationCostModel.highRateCharge = parseFloat(highRangeAmount).toFixed(2);
    destinationCostModel.totalAmount = parseFloat(totalAmount).toFixed(2);
    destinationCostModel.peakTimeCharge = parseFloat(peakTimeCharge).toFixed(2);
    destinationCostModel.fareAmount = parseFloat(fareAmount).toFixed(2);

    BookingModel.cgst = parseFloat(CGSTTaxAmount).toFixed(2);
    BookingModel.fareAmount = parseFloat(fareAmount).toFixed(2);
    BookingModel.highRangeCharge = parseFloat(highRangeAmount).toFixed(2);
    BookingModel.peakTimeCharge = parseFloat(peakTimeCharge).toFixed(2);
    BookingModel.surcharge = parseFloat(surchargeAmount).toFixed(2);
    BookingModel.sgst = parseFloat(SGSTTaxAmount).toFixed(2);
    BookingModel.tollCharge = parseFloat(Math.round(tollCharge)).toFixed(2);
    BookingModel.totalAmount = parseFloat(totalAmount).toFixed(2);
    BookingModel.waitingCharge = parseFloat(waitingTimeCharge).toFixed(2);
};
